import React from 'react'

const premium = () => [
  {
    question: 'What do I get with a free membership?',
    answer: <p>All of our apps and all of our activities will always remain free, forever. Teachers see their students&apos; results in the scorebook, and teachers may hover over the activity result to see the details.</p>
  },
  {
    question: 'What do I get with a premium membership?',
    answer: <p>With Quill Premium, teachers can access Quill Progress Reports, which allow teachers to easily view and download their data. Quill Progress Reports show teachers how students are progressing on the Common Core and which concepts they need help with. With Quill Premium for Schools, teachers and administrators can access a school-wide dashboard that shows student progress and standards mastered across the entire school.</p>
  },
  {
    question: 'How does payment work on a premium membership?',
    answer: <p>Quill Premium is provided on an annual license based on the school year. You may pay via credit card or check. Credit cards will be billed annually for Teacher and School Premium. If you pay with a check, Quill will issue an invoice to renew your subscription.</p>
  },
  {
    question: 'How much does premium cost?',
    answer: <p>Quill Premium is provided as a teacher license, school license, or district license. The teacher license covers all of the students for one teacher and costs $115 per year. The school license is a site-wide license that covers all teachers and students in the school. For districts, we provide custom pricing, on-site training, and district dashboards. <a href="https://quill.org/request_quote">Contact us to receive a demo.</a></p>
  },
  {
    question: 'Do you accept purchase orders?',
    answer: <p>Yes, we accept purchase orders. You may email a purchase order to <a href="mailto: sales@quill.org">sales@quill.org</a>. <a href="https://drive.google.com/file/d/1YPRiFMOthu3Jomf6IOG7nBQE2gvzbG2l/view">Access our W-9</a> and reach out with any questions at 510-671-0222.</p>
  },
  {
    question: 'Do you offer financial aid?',
    answer: <p>Yes, we provide Quill Premium for free to schools that have a demonstrated financial need. This funding is provided to select partners thanks to the support of our funders. <a href="https://docs.google.com/forms/d/1wiETnlf22j7JZin4vLogEt6DqsPsTKlD31bRgRU_7s0/viewform?ts=5db33f5f&edit_requested=true">Apply for financial aid.</a></p>
  },
  {
    question: 'Have more questions?',
    answer: <p>You can call us at 510-671-0222 or <a href="https://support.quill.org/en/">visit our Support Center.</a></p>
  }
]

export default premium
